module.exports = __webpack_public_path__ + "img/car-cog.d6889e6b.svg";